<div class="filter-button" (click)="matOp.toggle($event)" matRipple [matRippleCentered]="true">
	<button mat-button disableRipple="true">
		<mat-icon>filter_list</mat-icon>
	</button>
	<div class="types-info" *ngIf="filterIsOn">{{countTypes}} cols</div>
</div>

<p-overlayPanel #matOp styleClass="materials-filter-panel">
	<div class="checkboxes">
		<p-checkbox class="all-button" label="All" name="cols" [binary]="true" [(ngModel)]="showAll"
			(click)="showAllButton()"></p-checkbox>

		<p-checkbox *ngFor="let col of allMaterialsCols" label="{{col.header}}" name="cols" value="{{col.field}}"
			[(ngModel)]="selectedMaterialCols" (click)="clickOnFilter()"></p-checkbox>
	</div>

</p-overlayPanel>
